<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card" v-model="pageLangCode">
        <el-tab-pane
          :name="langItem.langCode"
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Banner Title 
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.title'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                    <el-input
                      v-model="langItem.title"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  File Type
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.fileType'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                     <el-select
                        v-model="langItem.fileType"
                      >
                        <el-option
                          v-for="item in [
                            { val: 1, text: 'Picture' },
                            { val: 2, text: 'Video' },
                          ]"
                          :key="item.val"
                          :label="item.text"
                          :value="item.val"
                        >
                        </el-option>
                      </el-select>
                  </el-form-item>
                </div>
              </div>
              <!--TODO-->
              <div class="form-group" v-if="langItem.fileType==1">
                <label class="col-sm-2 control-label">
                  Banner Image
                </label>
                <div class="col-sm-10">
                  <el-upload
                    class="upload-demo upload-image"
                    action="#"
                    multiple
                    :http-request="uploadFile"
                    :auto-upload="true"
                    accept=".png, .jpg , .jpeg"
                    :show-file-list="false"
                  >
                    <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                    <div class="input-group img-group">
                      <div class="text-center dropzone logo">
                        <div
                          class="addImage"
                          v-if="!langItem.showImageUrl"
                          style="width: 100%; padding-top: 25px; color: #fff"
                        >
                          <a class="addImageIcon btn btn-primary btn-circle">
                            <i class="el-icon-upload2"></i>
                          </a>
                          <p class="text-primary m-t-sm font14 suggestFont">
                            <slot name="sizeHint"></slot>
                          </p>
                        </div>
                        <div class="editImage" v-if="langItem.showImageUrl">
                          <div class="mask-bg"></div>
                          <img :src="langItem.showImageUrl" />
                          <div class="icon-center">
                            <span class="edit-icon">
                              <i class="el-icon-edit"></i>
                            </span>
                            <p class="font14 font-white editFont">Modify</p>
                            <p
                              class="text-primary font-white m-t-sm font14 suggestFont"
                            >
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                        </div>
                      </div> 
                    </div>
                  </el-upload>
                  <el-form-item
                    :prop="'langMaps.' + index + '.imageUrl'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input
                      @input="handleInputImageUrl($event,langItem)"
                      v-model="langItem.imageUrl"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                  <div>* The banner image is default mapping to three languages. For change the image by single language, please select the language and click the image for update.* </div>
                </div>
              </div>
              <!--TODO-->
              <template v-if='langItem.fileType==2'>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    Banner Video 
                  </label>
                  <div class="col-sm-10">
                    <el-form-item
                      :prop="'langMaps.' + index + '.imageUrl'"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur'
                      }"
                    >
                      <el-input
                      style="margin-bottom:22px;"
                        v-model="langItem.imageUrl"
                        show-word-limit
                      ></el-input>
                      <video
                            :src="
                              langItem.imageUrl
                            "
                            style="width:100%;"
                            controls="controls"
                          ></video>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    Thumbnail Image
                  </label>
                  <div class="col-sm-10">
                    <el-upload
                      class="upload-demo upload-image"
                      action="#"
                      multiple
                      :http-request="uploadFile"
                      :auto-upload="true"
                      accept=".png, .jpg , .jpeg"
                      :show-file-list="false"
                    >
                      <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;" class="el-upload__tip">The uploaded file should not exceed 5MB</div>
                      <div class="input-group img-group">
                        <div class="text-center dropzone logo">
                          <div
                            class="addImage"
                            v-if="!langItem.showImageThumbnailUrl"
                            style="width: 100%; padding-top: 25px; color: #fff"
                          >
                            <a class="addImageIcon btn btn-primary btn-circle">
                              <i class="el-icon-upload2"></i>
                            </a>
                            <p class="text-primary m-t-sm font14 suggestFont">
                              <slot name="sizeHint"></slot>
                            </p>
                          </div>
                          <div class="editImage" v-if="langItem.showImageThumbnailUrl">
                            <div class="mask-bg"></div>
                            <img :src="langItem.showImageThumbnailUrl" />
                            <div class="icon-center">
                              <span class="edit-icon">
                                <i class="el-icon-edit"></i>
                              </span>
                              <p class="font14 font-white editFont">Modify</p>
                              <p
                                class="text-primary font-white m-t-sm font14 suggestFont"
                              >
                                <slot name="sizeHint"></slot>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-upload>
                    <el-form-item
                      :prop="`langMaps[${index}].imageThumbnailUrl`"
                      :rules="{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'change',
                      }"
                    >
                      <el-input
                        style="display:none"
                        v-model="langItem.imageThumbnailUrl"
                        show-word-limit
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
              </template>
              <div class="form-group" v-if='langItem.fileType==1'>
                <label class="col-sm-2 control-label">
                  URL
                </label>
                <div class="col-sm-10">
                  <el-form-item 
                      :prop="`langMaps[${index}].jumpUrl`"
                      :rules="{
                        required: false, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-input
                      v-model="langItem.jumpUrl"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" >
                <label class="col-sm-2 control-label">
                  Type
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="systemType"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select 
                      v-model="detailInfo.systemType" 
                      @change="detailInfo.systemId=''"
                      v-bind:placeholder='$t("message.PleaseSelect")'
                      >
                        <el-option 
                        v-for="item in typeObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.systemType=='EVENT'">
                <label class="col-sm-2 control-label">
                  Event
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="systemId"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="detailInfo.systemId" filterable v-bind:placeholder='$t("message.PleaseSelect")'>
                        <el-option 
                        v-for="(item,index) in eventList"
                        :key="index"
                        :label="item.title"
                        :value="item.eventCode">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" v-if="detailInfo.systemType=='JCHANNEL'">
                <label class="col-sm-2 control-label">
                  J-Channel
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="systemId"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="detailInfo.systemId" v-bind:placeholder='$t("message.PleaseSelect")'>
                        <el-option 
                        v-for="item in eLearningList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      @click="checkEvent()"
                      v-if="(checkPermission('REWARDS_LIST_EDIT') &&
                          $route.query.id) ||
                          (checkPermission('REWARDS_LIST_ADD') &&
                            !$route.query.id)
                      "
                      >Save</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        langMaps: [],
        imageType:1,
        systemId:"",
        systemType:"EVENT",
      },
      typeObj:[],
      eventList:[],
      eLearningList:[],
      pageLangCode:'en_US',
      sortType: "asc",
      sortField: "title",
      uploadErr:false
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    }
  },
  watch: {
    _language: function() {
      this.setObj();
    },
    detailInfo: {
      handler: function() {
        this.$store.state.edit = true;
      },
      deep: true
    }
  },
  created() {
    var obj = [];
    this.pageLangCode = this.$store.state.userInfo.language[0].langCode;
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        description:"",
        imageUrl:"",
        showImageUrl:"",
        fileType:1,
        jumpUrl:''
      });
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.init();
    this.getEventListEvent();
    this.getELearningListEvent();
  },
  mounted() {},
  methods: {
    setObj: function() {
      this.typeObj = [
        {
          value: "JCHANNEL",
          label: "J-Channel"
        },
        {
          value: "EVENT",
          label: "Event"
        },
        {
          value: "IMAGE",
          label: "Image"
        }
      ];
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.imgbannerDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data == "000104"){
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if(data.data.result.systemType=='EVENT'){
          data.data.result.systemId+=''
        }
        data.data.result.langMaps.forEach(i=>{
          if(!i.fileType) i.fileType=1
        })
        this.$set(this, "detailInfo", data.data.result);
        setTimeout(function() {
          that.$store.state.edit = false;
        },500);
      } else {
        setTimeout(function() {
          that.$store.state.edit = false;
        },500);
      }
      this.setObj();
    },
    async getEventListEvent() {
      let obj = this.getAuthObj();
      obj.pageIndex = 1;
      obj.pageSize = 11111111;
      obj.title = this.searchName;

      obj.sortName = this.sortField;
      obj.sortType = this.sortType;
      obj.status = '5,6'
      obj.expired = 0
      obj.apiUrl = this.apiConfig.eventList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.$set(this, "eventList", data.data.result.events);
    },
    async getELearningListEvent() {
      let obj = this.getAuthObj();
      obj.pageIndex = 1;
      obj.pageSize = 11111111;
      obj.title = this.searchName;

      obj.sortName = this.sortField;
      obj.sortType = this.sortType;
      obj.apiUrl = this.apiConfig.eLearningSubList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;

      this.$set(this, "eLearningList", data.data.result['e-learning']);
    },
    checkEvent: function() {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
                that.callDelete();
              }
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
              }
            }
          ]
        });
      }
    },
    async uploadFile(params) {
      if(!this.handleCheckUploadFileSize(params.file)) return false
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.upload;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      const langObj =this.getObject(
        this.detailInfo.langMaps,
        this.pageLangCode
      )
      langObj[langObj.fileType==1?'imageUrl':'imageThumbnailUrl']= data.data.result.url;
      langObj[langObj.fileType==1?'showImageUrl':'showImageThumbnailUrl'] = data.data.result.showUrl;
      
      this.detailInfo.langMaps.forEach(item =>{
        if(!item.imageUrl){
          item[item.fileType==1?'imageUrl':'imageThumbnailUrl'] = data.data.result.url
          item[item.fileType==1?'showImageUrl':'showImageThumbnailUrl'] = data.data.result.showUrl
        }
      })
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          obj[key] = this.detailInfo[key];
        }
        var data;
        if (this.$route.query.id) {
          obj.id = this.detailInfo.id;
          obj.apiUrl = this.apiConfig.imgbannerUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.imgbannerCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) {}
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
    },
    handleCheckUploadFileSize(file){
      const sizeKB = file.size/1024
      if(sizeKB>5120){
        this.uploadErr = true
        return false
      }else{
        this.uploadErr = false
        return true
      }
    },
    handleInputImageUrl(e,langItem){
      console.log("!1111",e)
      langItem.showImageUrl = e
    }
  }
};
</script>
